// parallax.js
import $ from "jquery";

export function parallax() {
  $.fn.parallaxScroll = function () {
    const $window = $(window);
    let ticking = false;

    const elements = this.map(function () {
      const $el = $(this);
      const factor = parseFloat($el.data("background-parallax")) || 4;

      // Asegurar posición inicial top
      $el.css("background-position", "center top");

      return { $el, factor };
    }).get();

    function onScrollOrResize() {
      if (!ticking) {
        window.requestAnimationFrame(updatePositions);
        ticking = true;
      }
    }

    function updatePositions() {
      const scrollTop = $window.scrollTop();
      const windowHeight = $window.height();

      elements.forEach(({ $el, factor }) => {
        const offsetTop = $el.offset().top;
        const height = $el.outerHeight();

        // Si el elemento está completamente por encima o muy por debajo del viewport, no hacer nada
        if (scrollTop + windowHeight < offsetTop || scrollTop > offsetTop + height) {
          $el.css("background-position", "center top");
          return;
        }

        // Calcular cuánto se ha scrolleado DENTRO del rango visible del elemento
        const distanceIntoView = scrollTop + windowHeight - offsetTop;

        // Aplicar desplazamiento solo cuando está visible
        const moveY = Math.round(distanceIntoView / factor);

        $el.css("background-position", `center ${moveY}px`);
      });

      ticking = false;
    }

    $window.on("scroll.noahsParallax resize.noahsParallax", onScrollOrResize);
    updatePositions();

    return this;
  };

  $("[data-background-parallax]").parallaxScroll();
}
